<template>
  <div class="details">
    <Coordinates></Coordinates>
    <View class="d-view"></View>
    <SwapWorld style="margin-top: 16px" />
    <PlayerList class="d-players"></PlayerList>
  </div>
</template>

<style lang="scss">
.details {
  margin-left: 32px;
  max-width: 352px;
  width: 100%;
  max-height: 780px;

  .d-view {
    margin-top: 16px;
  }

  .d-players {
    margin-top: 16px;
  }
}
</style>

<script>
import Coordinates from "./Coordinates.vue";
import PlayerList from "./PlayerList.vue";
import SwapWorld from "./SwapWorld.vue";
import View from "./View.vue";

export default {
  name: "MapDetails",
  components: { Coordinates, View, PlayerList, SwapWorld },
};
</script>
